/**
 * Created by mac on 7/23/25
 */

const KingscupMerge3Adapter = {
    SubscribeToEvents: function () {
        const scrollToUnit = function () {
            const targetUnit = PseudoRandom.GET().choose(Map2d.currentMap.listAvailableUnits().filter((unit) => {
                const mineable = unit.findComponent(Mineable);
                if (!mineable) {
                    return false;
                }
                const task = mineable.getTask();
                return task && task.energy;
            }));

            if (targetUnit) {
                Map2d.currentMap.focusOnUnit(targetUnit, {
                    allowScrollWithFocus: true,
                    callback: function () {
                        FingerView.hintTap({ x: targetUnit.x, y: targetUnit.y }, { runOnce: true });
                    }
                });
            }
        };

        cleverapps.missionManager.on("kingsCupStart", (mission) => {
            if (mission.getType() === Mission.TYPE_KINGSCUP) {
                scrollToUnit();
            }
        }, Map2d.currentMap);

        cleverapps.eventBus.on("spendEnergy", (amount) => {
            if (!MissionManager.hasProperLocation(Mission.TYPE_KINGSCUP)) {
                return;
            }

            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (mission && mission.isRunning()) {
                if (cleverapps.focusManager.isFocused()) {
                    mission.logic.readyToUnlock = true;
                } else {
                    mission.logic.startCompetition();
                }

                mission.logic.earnPoints(amount);
            }

            cleverapps.personalBest.addPoint("kingscup", amount);
        }, Map2d.currentMap);

        Map2dLocation.UseEnergyMissions.push(Mission.TYPE_KINGSCUP);
    }
};

cleverapps.whenAllInitialized(() => KingscupMerge3Adapter.SubscribeToEvents());